import { render, staticRenderFns } from "./ViewMain.vue?vue&type=template&id=4010d1a0&scoped=true"
import script from "./ViewMain.vue?vue&type=script&lang=js"
export * from "./ViewMain.vue?vue&type=script&lang=js"
import style0 from "./ViewMain.vue?vue&type=style&index=0&id=4010d1a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010d1a0",
  null
  
)

export default component.exports